import { makeStyles } from '@material-ui/core/styles';
import { colors } from './theme';

const globalUseStyles = makeStyles((theme) => ({
  blueContainedButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  labelText: {
    color: theme.palette.primary.main,
  },
  transparentDataGrid: {
    '& .MuiToolbar-regular': {
      backgroundColor: 'transparent',
      color: 'black',
    },
    '& .MuiDataGrid-root': {
      '& .MuiDataGrid-colCell:focus:not(.MuiDataGrid-cellEditable)': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-root .MuiDataGrid-cell:focus-within:not(.MuiDataGrid-cellEditable)': {
      outline: 'none',
    },
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '0 !important',
    },
  },
  rulesDataGrid: {
    '& .MuiDataGrid-renderingZone': {
      maxHeight: 'none !important',
    },
    '& .MuiDataGrid-cell': {
      lineHeight: 'unset !important',
      maxHeight: 'none !important',
      whiteSpace: 'pre !important',
      padding: '14px !important',
    },
    '& .MuiDataGrid-row': {
      maxHeight: 'none !important',
    },
    '& .MuiToolbar-regular': {
      backgroundColor: 'transparent',
      color: 'black',
    },
    '& .MuiDataGrid-root': {
      '& .MuiDataGrid-colCell:focus:not(.MuiDataGrid-cellEditable)': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-root .MuiDataGrid-cell:focus-within:not(.MuiDataGrid-cellEditable)': {
      outline: 'none',
    },
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '0 !important',
    },
  },
  greenIcon: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.secondary.contrastText,
  },
  blueIcon: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.info.contrastText,
  },
  redIcon: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.secondary.contrastText,
  },
  orangeIcon: {
    backgroundColor: colors.orange,
    color: theme.palette.secondary.contrastText,
  },
  yellowIcon: {
    backgroundColor: colors.yellow,
    color: theme.palette.secondary.contrastText,
  },
  maroonIcon: {
    backgroundColor: colors.maroon,
    color: theme.palette.secondary.contrastText,
  },
  redIconReverse: {
    backgroundColor: theme.palette.secondary.contrastText,
    color: theme.palette.error.main,
  },
  smallAvatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  smallIconSize: {
    fontSize: '1rem',
  },
  styleOutOfBounds: {
    backgroundColor: 'wheat',
    '& .MuiInputBase-root': {
      backgroundColor: 'wheat',
    },
  },
}));

export default globalUseStyles;
